import { useCallback } from "react";
import { ITables } from "../all-types";
import { updateAllTables } from "../redux-store";
import { useAppDispatch } from "../redux-store/hooks";
import { useSocketEvent } from "./useSocketEvent";

export function TablesLiveSync() {
  const dispatch = useAppDispatch();
  const handler = useCallback((tables: ITables[]) => {
    dispatch(updateAllTables(tables));
  }, [dispatch]);
  useSocketEvent<ITables[]>("tables:list", handler);
  return null;
}
